(function ($) {
    
    function initSlider() {
        $('.slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: false,
            arrows: true,
            infinite: true,
            fade: true,
            adaptiveHeight: false
        });
    }
    function initCta() {
        if($('.hero-cta-section').length){
            $('.hero-cta-section').each(function(){ //loop through each element with the .dynamic-height class
                var cta = $(this);
                
                $('.hero-slide').css({
                    'padding-bottom' : cta.outerHeight() + 65 + 'px'
                });
            });
        }
    }


    // delay function to use on resize to prevent multiple resize events
    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();
    
    /* Document Ready */
	$(document).ready(function() {

        initSlider();
        initCta();
//        delayedFunctions();
	});

    // window resize
    window.onresize = function(event) {
        delay(function(){
            console.log('Window Resize...');
//            delayedFunctions();
            initCta();
        }, 500);
    };

})(jQuery);